import { sendWebsocketMessage } from '../../../../../App';
import { getMarketDataRoute } from '../../marketDataRouting';

export function removeSymbol(data) {
  if (data.symbol) {
    const route = getMarketDataRoute({
      dataSource: data.dataSource,
      brokerage: data.brokerage,
      messageType: 'removeSymbol',
      symbol: data.symbol,
    });
    if (!route.valid) {
      return;
    }
    const message = {
      messageType: 'removeSymbol',
      removeSymbol: {
        ...data,
        brokerage: route.brokerage,
      },
    };
    sendWebsocketMessage(message);
  }
}
